<script setup lang="ts">
import { computed } from 'vue';
import { useGettext } from 'vue3-gettext';
import { useRuntimeConfig } from '../composables/useRuntimeConfig';

const { $gettext } = useGettext();

const { config } = useRuntimeConfig();
const iceLink = computed(() => config.value?.iceLink ?? null);

const iceText = computed(() => $gettext("Take Action! Join Minnesota's music community in standing against ICE activities. Request your ICE OUT pin, support mutual aid, and take action with First Avenue and local venues. Join now!"));
</script>

<template>
  <a
    v-if="iceLink"
    :href="iceLink"
    class="block py-16"
    target="_blank"
    :aria-description="iceText"
  >
    <img
      src="/images/ice_out.png"
      class="w-full"
      :alt="iceText"
    >
  </a>
</template>
